import React from 'react'
import NavigationBar from '../../../../components/Navigationbar/Navigationbar'
import { useState } from 'react';
import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab, { tabClasses } from '@mui/joy/Tab';
import { TabPanel } from '@mui/joy';
import SubVergleichbearbeiten from './edit/SubVergleichbearbeiten';
import { useParams } from 'react-router-dom';
import { haspermission, hasspartenpermission } from '../../../../Script/Permission';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Token } from '../../../../Script/Session';
import { post } from '../../../../Script/Session';
import VerantwortlicheView from './TabPanels/VerantwortlicheView';
import TarifHome from './TabPanels/TarifHome';
function VergleichsSubhome() {
  const [wit, setwith] = useState("90.5%");
  const [index, setIndex] = React.useState(0);
  const { kath, id } = useParams();
  const [canEditpage, seteditpage] = useState(false);
  const [data, setData] = useState("");

  const navigate = useNavigate();
  useEffect(() => {
    const fetchVereinData = async () => {
      const body = {
        token: Token.get(),
        action: "get",
        target: Number(id)

      };

      try {
        let response = await post(body, "/vergleiche/sub-sparten");
        if (response === "LOGOUT") {
          navigate("/");
          return;
        }

        setData(JSON.parse(response));
        seteditpage(hasspartenpermission(JSON.parse(response).id));
        console.log(response);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchVereinData();
  }, [navigate]);
  function update() {
    const body = {
      token: Token.get(),
      action: "get",
      target: Number(id)

    };

    try {
      let response = post(body, "/vergleiche/sub-sparten");
      if (response === "LOGOUT") {
        navigate("/");
        return;
      }

      setData(JSON.parse(response));
      console.log(response);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }






  return (
    <>
      <div style={{ width: wit, position: "fixed", flexDirection: "column", top: "0", right: "0", backgroundColor: "white", height: "100vh", display: "flex", alignItems: "center" }}>
        <Tabs
          aria-label="Pipeline"
          value={index}
          onChange={(event, value) => {
            if (value === 4 && !canEditpage) {
              alert("Keine Berechtigung!");
              return;
            }


            setIndex(value)
          }}
          sx={{ mt: 0, width: "100%", height: "100vh" }}
        >
          <TabList
            sx={{
              pt: 1,
              justifyContent: 'center',
              [`&& .${tabClasses.root}`]: {
                flex: 'initial',
                bgcolor: 'transparent',
                '&:hover': {
                  bgcolor: 'transparent',
                },
                [`&.${tabClasses.selected}`]: {
                  color: 'primary.plainColor',
                  '&::after': {
                    height: 2,
                    borderTopLeftRadius: 3,
                    borderTopRightRadius: 3,
                    bgcolor: 'primary.500',
                  },
                },
              },
            }}
          >
            <Tab
              variant="soft"
              color="neutral">Tarife</Tab>
            <Tab
              variant="soft"
              color="neutral">Verantwortliche</Tab>
            <Tab
              variant="soft"
              color="neutral">Bearbeiten</Tab>
          </TabList>
          <TabPanel value={0} sx={{ overflowY: "auto" }}><TarifHome data={data} caneditpage={canEditpage} upd={update} /></TabPanel>
          <TabPanel value={1}><VerantwortlicheView data={data} /></TabPanel>
          <TabPanel value={2} sx={{ p: 0 }}><SubVergleichbearbeiten d={data} upd={update} overn={kath} /></TabPanel>
        </Tabs>





      </div>
      <NavigationBar state={"vergleiche"} back={true} />
    </>
  )
}

export default VergleichsSubhome
